import { mixins, styled } from '@bob/library'
import {
  SharedBackground,
  SharedBackgroundProps,
  spotCampaignBreakpoint,
} from '@websrc/Spot/Campaign/Components/SpotCampaignShared.style'

export const Wrapper = styled.div`
  ${mixins.padding(20)}
  ${mixins.media.min.custom(spotCampaignBreakpoint, 'screen')} {
    display: none;
  }
`

export const Asset = styled.div`
  min-height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  ${mixins.media.max.tablet} {
    max-height: 40vh;
  }

  ${mixins.media.max.phone} {
    max-height: 30vh;
  }
`

export const Content = styled.div`
  ${mixins.margin(0, 'auto')}
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Background = styled.div<SharedBackgroundProps>`
  ${SharedBackground}
`
